export default {
	"CountDown.CountdownToTheEvent": "Countdown to the event:"
}